import React from "react";

const EmployeePageContext = React.createContext();

export { EmployeePageContext };
